export function initTable(){

    const tables = document.querySelectorAll('table');
    tables.forEach(table => {
        const wrapper = document.createElement('div');
        wrapper.classList.add('o-table');
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
}